import React from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { useMutation, gql } from '@apollo/client'
import { CheckIcon, CloseIcon } from '@chakra-ui/icons'
import { useToast, Text, Input, Button, Table, Thead, Tbody, Th, Tr, Td } from '@chakra-ui/react'

import { Card, Page, PageHeader } from 'components'

import { useDimensionListQuery } from '../hooks'

const DIMENSION_WEIGHTS_UPDATE_MUTATION = gql`
  mutation DimensionWeightsUpdate($dimensionWeights: [DimensionWeightsUpdate!]) {
    dimensionWeightsUpdate(dimensionWeights: $dimensionWeights) {
      id
      name
      weight
      errors {
        field
        message
      }
    }
  }
`

export const DimensionWeightsPage = () => {
  const toast = useToast()
  const navigate = useNavigate()
  const { register, handleSubmit, errors } = useForm()
  const { data, error } = useDimensionListQuery()
  const [dimensionWeightsUpdate] = useMutation(DIMENSION_WEIGHTS_UPDATE_MUTATION)

  const cancel = () => navigate('..')

  const onSubmit = async data => {
    await dimensionWeightsUpdate({ variables: data })
    toast({
      status: 'success',
      title: 'Ponderaçōes alteradas.',
      description: 'Ponderaçōes de dimensão alteradas com sucesso.'
    })
    navigate('..')
  }

  if (error) {
    return navigate('/login')
  }

  return (
    <Page as='form' onSubmit={handleSubmit(onSubmit)}>
      <PageHeader heading='Editar Ponderaçōes' onBack={() => navigate('..')}>
        <Button
          variant='outline'
          colorScheme='green'
          leftIcon={<CheckIcon />}
          type='submit'
          tabIndex='0'>
          Guardar
        </Button>
        <Button
          variant='outline'
          colorScheme='red'
          leftIcon={<CloseIcon />}
          onClick={cancel}
          tabIndex='0'>
          Cancelar
        </Button>
      </PageHeader>

      <Card p={3}>
        <Table>
          <Thead>
            <Tr>
              <Th>
                <Text>Nome</Text>
              </Th>
              <Th>
                <Text id='col_weight'>Ponderação</Text>
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {data?.map(({ id, name, weight }, index) => (
              <Tr key={index}>
                <Th id={`cell_weight_${index}`}>
                  <Text>{name}</Text>
                </Th>
                <Td py={2}>
                  <input
                    type='hidden'
                    defaultValue={id}
                    ref={register({ required: true })}
                    name={`dimensionWeights[${index}].id`}
                  />
                  <Input
                    isRequired
                    type='number'
                    min={0}
                    max={100}
                    step={0.01}
                    defaultValue={weight}
                    aria-labelledby={`col_weight cell_weight_${index}`}
                    ref={register({ required: true })}
                    name={`dimensionWeights[${index}].weight`}
                    isInvalid={errors.dimensionWeights?.[index]?.weight}
                  />
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Card>
    </Page>
  )
}

export default DimensionWeightsPage
